"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for forbidden responses on school operations
 * @param {string} schoolId the school id
 */
class ForbiddenForSchoolError extends client_library_1.ExtendableError {
    constructor(schoolId) {
        super(`Forbidden operation on externally managed school. ${schoolId}`);
        this.schoolId = schoolId;
    }
}
exports.default = ForbiddenForSchoolError;
//# sourceMappingURL=ForbiddenForSchoolError.js.map